<template>
  <div id="app">

    <rxmenu/>

    <div class="ccnt">

      <transition name="fade">
        <div class="content">
            <router-view/>
        </div>
      </transition>

    </div>

    <transition name="fade">
      <fixedmessageicon v-if="iconshow" />
    </transition>

    <rxfooter/>

  </div>

</template>

<script>

import rxfooter from '@/components/rx/footer/index.vue'
import rxmenu from '@/components/rx/menu/index.vue'

export default {
    components: {
      rxfooter,
      rxmenu,
    },
    computed:{

        iconshow : function(){
          return this.$store.state.icon ? true : false
        },

    },

    watch : {
      $route(to, from) {

      }
    },

    methods : {
      
    }
}

</script>

<style lang="sass" src="./index.sass"></style>


